import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';

function EventItem({ event, handleClickEvent, handleDuplicateEvent }) {
  return (
    <div
      className="w-full flex flex-row justify-between items-center p-5 cursor-pointer hover:bg-slate-100"
      onClick={handleClickEvent}>
      <div className="h-full flex flex-row gap-x-5">
        <img
          className="h-32 w-auto shadow-md block rounded-md"
          src={event.main_image ? event.main_image.file : getImage('img-ph.png')}
          alt={event.main_image ? event.main_image.label : 'Non renseignée'}
        />
        <img
          className="h-32 w-auto shadow-md block rounded-md"
          src={event.secondary_image ? event.secondary_image.file : getImage('img-ph.png')}
          alt={event.secondary_image ? event.secondary_image.label : 'Non renseignée'}
        />
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col gap-y-0.5">
            <h3 className="text-xl font-bold text-slate-700 ">{event.title}</h3>
            <p>{`${event.place_name} - ${moment(event.start_dt).format('LLL')}`}</p>
          </div>

          <div className="flex flex-row gap-1">
            <Tag tag={getConstant('melismes.common.statusTypes', event.status)} />
            <Tag
              tag={{
                label: event.program?.title,
                bgColor: 'bg-slate-700',
                icon: 'program'
              }}
            />
          </div>
        </div>
      </div>

      <Button
        rounded
        icon="pi pi-clone"
        className="h-12 w-12"
        tooltip="Dupliquer l'évènement"
        tooltipOptions={{ position: 'left' }}
        onClick={(e) => {
          e.stopPropagation();
          handleDuplicateEvent(event);
        }}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default EventItem;
